export type FilterPreset = 'none' | 'sepia' | 'noise' | 'crt' | 'dots' | 'film';

export type EditedBy = 'bot' | 'creator' | 'migrator';

export type CharacterColor = 'blue' | 'brown' | 'green' | 'orange' | 'purple' | 'red' | 'teal' | 'yellow';

export enum CharacterMotionType {
  Normal = 0,
  Entering = 1,
  Exiting = 2
}

export type CharacterTransitionType = 'in' | 'out';

export type CameraPreset = 'closeup' | 'medium' | 'cowboy' | 'wide';

export type CameraEase = 'inOut1' | 'shake';

export type ChoiceType = 'blue' | 'premium';

export type ChoiceIdV1 = 'a' | 'b' | 'c';

export type BubbleMode = 'character' | 'scene';

export type RightOrLeft = 1 | -1;

export type CharacterId = 'a' | 'b' | 'c';

export type TimelineId = `t${string}`;
export type StepId = `s${string}`;
export type ChoiceId = `c${string}`;
export type CharSlotId = `cs${string}`;
export type AnimationKey = `a_${string}`;

export type ParallaxId = `p${string}`;

export enum RevealType {
  /**
   * User can choose while there's time left. Then auto reveals when time expires. No reveal button.
   */
  CHOICE_AUTO = 'ChoiceAutoReveal',
  /**
   * User can choose while there's time left. Then presses reveals when time expires. Show reveal button.
   */
  CHOICE_CLICK = 'ChoiceClickReveal',
  /**
   * User never chooses anything, all automatic. No choice button, no reveal button.
   */
  AUTO = 'AutomaticReveal',
  /**
   * User presses reveal to choose one at random. No choice button, show reveal button.
   */
  CLICK = 'RequiresClickReveal',
}

